/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{83E2213B-DF3D-4470-A419-A167F8E89140}",
  "sitecoreApiHost": "https://www.interactivestrategies.com",
  "jssAppName": "is-jss",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/is-jss",
  "graphQLEndpoint": "https://www.interactivestrategies.com/api/is-jss?sc_apikey={83E2213B-DF3D-4470-A419-A167F8E89140}"
};